import React, { Component } from "react";
import firebase, { database } from "../../firebase";
import CrmTourCallout from "./CrmTourCallout";
import { getTourStep, setTourStep, neverShowTour } from "./crmTour";

// Banner on the CRM dashboard. "Create Inquiry" opens a small form whose
// store name and contact no are pre-filled from the selected store; the user
// can unlock them with Edit before saving the inquiry to Firestore.
class InquiryBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      editing: false,
      saving: false,
      saved: false,
      error: "",
      storeName: "",
      contactNo: "",
      showTour: getTourStep() === "inquiry",
    };
  }

  endTour = () => {
    setTourStep("done");
    this.setState({ showTour: false });
  };

  neverShowTour = () => {
    neverShowTour();
    this.setState({ showTour: false });
  };

  openForm = () => {
    const { storeName, contactNo } = this.props;
    setTourStep("done");
    this.setState({
      showTour: false,
      open: true,
      editing: false,
      saving: false,
      saved: false,
      error: "",
      storeName: storeName || "",
      contactNo: contactNo || "",
    });
  };

  closeForm = () => this.setState({ open: false });

  saveInquiry = async () => {
    const { user, storeID } = this.props;
    const storeName = this.state.storeName.trim();
    const contactNo = this.state.contactNo.trim();

    if (!storeName || !contactNo) {
      return this.setState({ error: "Store name and contact no are required" });
    }

    this.setState({ saving: true, error: "" });

    try {
      await database.collection("Inquiry").add({
        Type: "WhatsApp Brand Name",
        StoreName: storeName,
        ContactNo: contactNo,
        StoreID: storeID || (user && user.store && user.store.key) || "",
        RegistrationID: (user && user.user && user.user.RegistrationID) || "",
        CreatedBy: (user && user.user && user.user.Name) || "",
        CreatedOn: firebase.firestore.FieldValue.serverTimestamp(),
      });
      neverShowTour();
      this.setState({ saving: false, saved: true, editing: false });
    } catch (error) {
      console.error("Inquiry save error:", error);
      this.setState({ saving: false, error: "Could not save the inquiry. Please try again." });
    }
  };

  render() {
    const { open, editing, saving, saved, error, storeName, contactNo, showTour } = this.state;

    return (
      <div className="wa-banner">
        <div className="wa-banner-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" width="26" height="26" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 4.5a11.5 11.5 0 0 0-9.9 17.3L4.5 27.5l5.9-1.5A11.5 11.5 0 1 0 16 4.5z" />
            <path d="M12.3 10.8c.3-.6.6-.6 1-.6l.7.6.9 2.1c0 .4-.4.8-.7 1.2.9 1.7 2.1 2.7 3.8 3.6.4-.4.8-1 1.2-1l2.1 1c.1.5 0 1-.4 1.5-.5.7-1.5 1-2.4.8-3.6-1-6.1-3.4-7.2-6.9-.1-.8.2-1.6 1-2.3z" fill="#fff" stroke="none" />
          </svg>
        </div>
        <div className="wa-banner-text">
          <h3 className="wa-banner-title">Send WhatsApp campaigns with your brand name</h3>
          <p className="wa-banner-sub">Reach your customers from your own WhatsApp business name — not a shared number.</p>
        </div>
        <button type="button" id="crm-inquiry-btn" className="wa-banner-btn" onClick={this.openForm}>
          Create Inquiry
        </button>

        {showTour && !open && (
          <CrmTourCallout
            targetSelector="#crm-inquiry-btn"
            step={2}
            totalSteps={2}
            title="Inquire now"
            text="Send campaigns to your customers from your own WhatsApp number. Click here and we will set it up for you."
            onSkip={this.endTour}
            onNever={this.neverShowTour}
          />
        )}

        {open && (
          <div className="inquiry-backdrop" onClick={this.closeForm}>
            <div className="inquiry-modal" onClick={(e) => e.stopPropagation()}>
              <div className="inquiry-header">
                <h4>Create Inquiry</h4>
                {!saved && (
                  <button
                    type="button"
                    className="inquiry-link-btn"
                    onClick={() => this.setState({ editing: !editing })}
                  >
                    {editing ? "Done" : "Edit"}
                  </button>
                )}
              </div>

              {saved ? (
                <p className="inquiry-success">Inquiry saved. We will contact you shortly.</p>
              ) : (
                <>
                  <label className="inquiry-label">Store Name</label>
                  <input
                    className="inquiry-input"
                    value={storeName}
                    readOnly={!editing}
                    onChange={(e) => this.setState({ storeName: e.target.value })}
                  />

                  <label className="inquiry-label">Contact No</label>
                  <input
                    className="inquiry-input"
                    value={contactNo}
                    readOnly={!editing}
                    onChange={(e) => this.setState({ contactNo: e.target.value })}
                  />

                  {error && <p className="inquiry-error">{error}</p>}
                </>
              )}

              <div className="inquiry-actions">
                <button type="button" className="inquiry-cancel-btn" onClick={this.closeForm}>
                  {saved ? "Close" : "Cancel"}
                </button>
                {!saved && (
                  <button type="button" className="wa-banner-btn" onClick={this.saveInquiry} disabled={saving}>
                    {saving ? "Saving..." : "Submit"}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default InquiryBanner;
